module.exports = __webpack_public_path__ + "static/media/Drivstoff.b2d5e8d0.m4a";